<template>
    <div class="form">
        <div class="form-group">
            <h1 class="h2" style="margin-bottom: 1rem">
                <span>{{ title }}</span>
                <div class="select-wrapper --header">
                    <select v-model="year" @change="getChallenges">
                        <option v-for="item in $store.getters.getYears" :key="item" :value="item">{{ item }}</option>
                    </select>
                </div>
            </h1>
        </div>
        <div class="form-group" v-if="$store.getters.getPlaces.length > 0">
            <div class="select-wrapper">
                <span v-if="place === null" class="select-placeholder">Wybierz sklep</span>
                <select v-model="place" @change="getChallenges">
                    <option v-for="item in $store.getters.getPlaces" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HeaderChallenges',
        props: ['title'],
        computed: {
            place: {
                set(place){
                    this.$store.commit('USER_SET_PLACE', place)
                },
                get(){
                    return this.$store.state.user.currentPlace || null
                }
            },
            year: {
                set(year){
                    this.$store.commit('USER_SET_YEAR', year)
                },
                get(){
                    return this.$store.state.user.currentYear || null
                }
            }
        },
        methods: {
            getChallenges: function() {
                this.$store.dispatch('CHALLENGES_REQUEST');
            }
        }
    }
</script>